import { Card, Space } from 'antd';
import React from 'react';
import { DynamicObjectType } from 'types/commons';
import ProductsOrder from './ProductsOrder';
// import OtherInformation from './OtherInformation';
import OrderHistories from './OrderHistories';

const LeftContent = ({ data }: { data: DynamicObjectType }) => {
  return (
    <div>
      <Space size={20} direction="vertical" className="w-full">
        <Card title="Product information">
          <ProductsOrder
            isRejectReturn
            data={data?.order}
            items={data?.items}
            fulfillmentInspection={data?.fulfillmentInspection}
          />
        </Card>
        {/* <OtherInformation data={data} /> */}
        <OrderHistories data={data} />
      </Space>
    </div>
  );
};

export default LeftContent;
